export default [
    ['PAGE', '页面'],
    ['MODAL', '弹窗'],
]
